import { ErrorHandler } from '@angular/core';

export class ConsoleErrorHandler extends ErrorHandler {
  handleError(error: unknown): void {
    console.error(error);
  }
}
